"use client"

import { coords, gMsg, ManagerInstance, notifyStatus } from '@/sharedTypes/coreTypes';
import toast from '@/components/ui/custom-toast';

export const GetManagerEntity = (): ManagerInstance | null => {
  if (typeof window !== 'undefined') {
    return (window as any).manager;
  }
  return null;
};

// export a safe version of managerentity that checks for window existence
export const ManagerEntity = new Proxy<ManagerInstance >({} as ManagerInstance , {
  get: (target: any, prop: string | symbol) => {
    const manager = GetManagerEntity();
    if (manager && typeof prop === 'string') {
      return manager[prop];
    }
  },
  set: (target: any, prop: string | symbol, value: any) => {
    const manager = GetManagerEntity();
    if (manager && typeof prop === 'string') {
      manager[prop] = value;
      return true;
    }
    return false;
  }
});

// Function to convert gMsg to toast
export const showGMsgAsToast = (gMsgInstance: gMsg) => {
  if (!gMsgInstance) return;

  // Map notifyStatus to toast types
  const statusToToastType = {
    [notifyStatus.success]: 'success' as const,
    [notifyStatus.failed]: 'error' as const,
    [notifyStatus.warning]: 'warning' as const,
  };

  const toastType = statusToToastType[gMsgInstance.status] || 'info';

  toast({
    title: toastType === 'success' ? 'Success' : 
           toastType === 'error' ? 'Error' : 
           toastType === 'warning' ? 'Warning' : 'Info',
    description: gMsgInstance.msg,
    type: toastType,
    duration: 4000, // 4 seconds
  });
};

// Initialize global functions only in browser environment
if (typeof window !== 'undefined') {
  console.log("Registering global functions...")
  window.popup = (message: string, status: notifyStatus = notifyStatus.success, position?: coords) => {
    if (ManagerEntity) {
      const gMsgInstance = new gMsg(message, status, position);
      ManagerEntity.gMsg = gMsgInstance;
    }
  }
  window.spinner = {
    show: (message: string, position?: coords) => {
      console.log("Window spinner show called")
      if (ManagerEntity) {
        ManagerEntity.spinnerMsg = message;
        console.log("Manager entity, spinner msg: ", ManagerEntity.spinnerMsg)
        if (position) {
          ManagerEntity.spinnerPos = position;
        }
      }
    },
    hide: () => {
      if (ManagerEntity) {
        ManagerEntity.spinnerMsg = '';
        ManagerEntity.spinnerPos = null;
      }
    }
  }
  console.log("Window.spinner after registering: ", window.spinner)
}

export {}; // This export is needed to make this a module
